var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 13,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.609 1.6h12.16v14.897H7.609V1.6Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.678 2.529c-2.819 0-5.11 2.917-5.11 6.503 0 3.585 2.291 6.503 5.11 6.503 2.817 0 5.11-2.918 5.11-6.503 0-3.586-2.293-6.503-5.11-6.503Zm0 13.935c-3.33 0-6.04-3.333-6.04-7.432 0-4.1 2.71-7.432 6.04-7.432 3.329 0 6.038 3.333 6.038 7.432s-2.71 7.432-6.039 7.432Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 15,
    width: 17,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 15.005h15.822v10.809H1.6v-10.81Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.678 25.755c-8.184 0-12.078-.533-12.078-3.56 0-2.083 2.597-5.403 6.79-7.14a.462.462 0 0 1 .606.25c.1.238-.013.51-.25.608-3.664 1.517-6.217 4.527-6.217 6.282 0 1.967 2.813 2.631 11.149 2.631 1.228 0 2.287-.012 3.236-.041a.464.464 0 1 1 .03.929c-.96.027-2.029.041-3.266.041Z",
    fill: "currentColor"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.062 17.858a.455.455 0 0 1-.285-.1 13.492 13.492 0 0 0-3.168-1.846.463.463 0 0 1-.25-.607.462.462 0 0 1 .606-.25 14.33 14.33 0 0 1 3.386 1.973.464.464 0 0 1-.289.83Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 13,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.276 18.275H30.4V30.4H18.276V18.275Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.361 19.251a5.115 5.115 0 0 0-5.11 5.11 5.115 5.115 0 0 0 5.11 5.11 5.115 5.115 0 0 0 5.11-5.11 5.115 5.115 0 0 0-5.11-5.11Zm0 11.149a6.046 6.046 0 0 1-6.038-6.039c0-3.33 2.709-6.039 6.038-6.039 3.33 0 6.039 2.71 6.039 6.04 0 3.329-2.71 6.038-6.039 6.038Z",
    fill: "currentColor"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.361 27.612a.466.466 0 0 1-.464-.464v-5.574a.466.466 0 0 1 .929 0v5.574a.465.465 0 0 1-.465.464Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.148 24.826h-5.574a.465.465 0 0 1 0-.93h5.574a.466.466 0 0 1 0 .93Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.a175652444db8aa20a4658f6d67a836b.svg";
export { ForwardRef as ReactComponent };